export const state = () => ({
  list: [],
})
